import React, { useRef, useState, useEffect } from 'react'
import styles from './ProductSlider.module.scss'
import ProductCard from '../ProductCard'
import { SlideProductCardSkeleton } from '../skeletons'
import { ArrowLeftIcon, ArrowRightIcon } from 'shared/assets'
import { Link } from 'react-router-dom'
import ArrowRightLong from "assets/icons/Global/ArrowRightLong";

type TProductSlider = {
  productList: any[]
  loading: boolean
  name?: string
  is_bestsellers?: boolean
}

const ProductSlider = ({ productList, loading = false, name  , is_bestsellers = false}: TProductSlider) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const productFilter =
    name === 'Best Sellers' ? 'bestsellers' : name === 'Новинки' ? 'latest' : name === 'Знижки' ? 'special' : ''

  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  const updateScrollButtons = () => {
    const el = scrollRef.current
    if (!el) return 1

    setCanScrollLeft(el.scrollLeft > 0)
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1)
  }

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return

    const scrollAmount = scrollRef.current.offsetWidth / 1.5
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return

    updateScrollButtons()

    const handleScroll = () => updateScrollButtons()
    el.addEventListener('scroll', handleScroll)

    window.addEventListener('resize', updateScrollButtons)

    return () => {
      el.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', updateScrollButtons)
    }
  }, [])

  const productCardSkeletons = Array.from({ length: 4 }).map((_, index) => (
    <SlideProductCardSkeleton key={`skeleton-${index}`} />
  ))

  const renderCardComponents = productList?.map((item: any, index: number) => (
    <ProductCard
      key={`${item.id}-${index}`}
      data={item}
      className={styles.wrapper__item}
      isWishlist={item?.in_wishlist}
    />
  ))

  useEffect(() => {
    const timeout = setTimeout(() => {
      updateScrollButtons()
    }, 50)

    return () => clearTimeout(timeout)
  }, [productList])

  const isEmpty = !loading && (!productList || productList.length === 0)

  return (
    <div className={styles.wrapper__container}>
      <div className={styles.header}
           style={productFilter === 'bestsellers' ? { justifyContent: 'center' } : {}}
      >
        {
            productFilter !== 'bestsellers' &&
        <span
          className={`${styles.icon} ${(!canScrollLeft || isEmpty) ? styles.disabled : ''}`}
          onClick={() => canScrollLeft && !isEmpty && scroll('left')}
        >
          <ArrowLeftIcon />
        </span>
        }
        <div className={styles.headers}>
          <h2>{is_bestsellers ? 'Best Sellers' : name || 'Новинки'}</h2>
          {!isEmpty && (
            <Link to={`products?filter=${productFilter}`}>
              <div className={styles.link}>
                {productFilter !== 'bestsellers' ? 'Дивитись все' : 'Більше товарів'}
                 <ArrowRightLong />
              </div>
            </Link>
          )}
        </div>
        {
          productFilter !== 'bestsellers' &&
        <span
          className={`${styles.icon} ${(!canScrollRight || isEmpty) ? styles.disabled : ''}`}
          onClick={() => canScrollRight && !isEmpty && scroll('right')}
        >
          <ArrowRightIcon />
        </span>
        }
      </div>
      {isEmpty ? (
        <div className={styles.empty_state}>
          <p>Наразі немає товарів у цій категорії</p>
        </div>
      ) : productFilter === 'bestsellers'  ? (
          <div className={styles.grid_wrapper}>
            {loading ? productCardSkeletons : renderCardComponents}
          </div>
      ) : (
          <div  className={styles.wrapper} ref={scrollRef}>
            {loading ? productCardSkeletons : renderCardComponents}
          </div>
      )}
    </div>
  )
}

export default ProductSlider
